import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, MenuController, IonicApp, App, Events, ModalController, PopoverController, ViewController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { boostrapConfig } from '../config';
import { androidStatusBarColor } from '../config'
import { AppState } from '../config/state';

import { ScreenPage } from '../pages/screen/screen';

import { ConfigProvider, coButton } from '../providers/config/config';
import fetch from 'node-fetch';
import { ClientDetailsProvider } from '../providers/client-details/client-details';
import { ColorConvertProvider } from '../providers/color-convert/color-convert';
import { EventsProvider } from '../providers/events/events';
import { CoLocationSelectorPage } from '../pages/co-location-selector/co-location-selector';
import { LocationsProvider } from '../providers/locations/locations';
import { LoginProvider } from '../providers/login/login';
import { IpcService } from '../providers/ipc/ipc';
import { CoNgxKeyboardComponent } from '../components/co-ngx-keyboard/co-ngx-keyboard';
import { ListProvider } from '../providers/list/list';
import { TimeoutProvider } from '../providers/timeout/timeout';
import { IlsProvider } from '../providers/ils/ils';
import { CoRoamLoginComponent } from '../components/co-roam-login/co-roam-login';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { DatabaseProvider } from '../providers/database/database';
import { StaffAuthProvider } from '../providers/staff-auth/staff-auth';
import { ApiProvider } from '../providers/api/api';
import { LoadingPage } from '../pages/loading/loading';
import { ToastAlertsProvider } from '../providers/toast-alerts/toast-alerts';
import { CoAppSelectorPage } from '../pages/co-app-selector/co-app-selector';

declare global {
  interface Window { Bridge: any; }
}

// declare var Keyboard:any;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  burgerMenu: any;
  menuSide: string = "right";
  resetFunction: any;
  timeoutID: any;
  timeoutWarningID: any;
  osk: any;
  oskShowTimer: any;
  oskCloseTimer: any;
  timeoutInterval: number;
  timeoutWarning: number;
  forceTimeout = false;
  inactivePopover: any = false;
  keyboard: any;
  constructor(platform: Platform, statusBar: StatusBar, private splashScreen: SplashScreen, private _db: DatabaseProvider, private config: ConfigProvider, private state: AppState, private clientDetails: ClientDetailsProvider, private _menu: MenuController, private _ionicApp: IonicApp, private _app: App, private colorConvert: ColorConvertProvider, private eventsProvider: EventsProvider, private events: Events, private locations: LocationsProvider, private modalCtrl: ModalController, private ipc: IpcService, private popoverCtrl : PopoverController, private toast: ToastAlertsProvider, private loginProvider: LoginProvider, private listProvider: ListProvider, private timeoutProvider : TimeoutProvider, private ils : IlsProvider, private analytics: AnalyticsProvider, private _staffProvider: StaffAuthProvider, private _apiProvider: ApiProvider) {
    // this.deeplinks.route({
    //   '/test': DiscoverPage,
    //   '/discover': DiscoverPage,
    // }).subscribe((match) => {
    //   // match.$route - the route we matched, which is the matched entry from the arguments to route()
    //   // match.$args - the args passed in the link
    //   // match.$link - the full link data
    //   console.log('Successfully matched route', match);
    // }, (noMatch) => {
    //   // noMatch.$link - the full link data
    //   console.log('Got a deeplink that didn\'t match', noMatch.fragment);
    // });


platform.ready().then(() => {

	  if(!window.Bridge){
	  window.Bridge={
        coPrint:(data)=>{
			var win = window.open("");
			win.document.body.innerHTML = data.receipt;
			// console.log('printing not supported in this build')
		},
		coSip2:false,
		coLog:{
			error:msg=>console.error(msg),
			warn:msg=>console.warn(msg),
			info:msg=>console.info(msg),
			verbose:msg=>console.log(msg),
			debug:msg=>console.log(msg),
			silly:msg=>console.log(msg),
		},
		log:msg=>console.log(msg)
	  }
	}else if(window.Bridge.coLog){
		// define a new console
		var console=(function(oldCons){
			return {
				log: function(text){
					window.Bridge.coLog.info(text);
				},
				info: function (text) {
					window.Bridge.coLog.debug(text);
				},
				warn: function (text) {
					window.Bridge.coLog.warn(text);
				},
				error: function (text) {
					window.Bridge.coLog.error(text);
				}
			};
		}(window.console));

		// Then redefine the old console
		var w:any = window;
		w.console = console;
		w.onerror =  (msg, url, lineNo, columnNo, error) => {
			if(typeof msg==='object'){
				let error:ErrorEvent = msg;
				window.Bridge.coLog.error(`${error.message} in ${error.filename} line ${error.lineno}`);
			}else{
				window.Bridge.coLog.error(`${msg} in ${url} line ${lineNo}`);
			}
			return false;
		  }
	}
	this.events.subscribe('login:dismiss', () => {
		if(this.state.loggedInPatronId)this.logout();
	});

      this.state.cacheTime = 3600; //Default time to keep items cached in seconds
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
	    let lintWindow: any = window; //lint was breaking shit
      if(lintWindow.cordova && lintWindow.cordova.plugins && !platform.is('core')) {
        lintWindow.cordova.plugins.Keyboard.hideKeyboardAccessoryBar(false);
        lintWindow.Keyboard.setResizeMode('ionic');
        lintWindow.Keyboard.disableScroll(false);
      }
      // set authentication
      this.state.authentication = {
        key: boostrapConfig.api.authentication.key,
        secret: boostrapConfig.api.authentication.secret
      }

      if (boostrapConfig.api['ssoUrl']) {
        this.state.ssoUrl = boostrapConfig.api['ssoUrl'];
      }

      if (boostrapConfig.mode === 'ROAM' || boostrapConfig.mode === 'ROAMLITE') {
        this.state.productType = 'ROAM_V2';
      } else if (boostrapConfig.mode === 'ROOMBOOKER') {
        this.state.productType = 'ROOM_BOOKER';
      } else if (boostrapConfig.mode === '') {
        this.state.productType = 'ROOM_BOOKER';
      }

      if (boostrapConfig.appId>0) {
        this.state.appId = boostrapConfig.appId;
        this.events.subscribe('staff:logout', () => {
          this._staffProvider.clear();
          this.state.authentication = {
            key: boostrapConfig.api.authentication.key,
            secret: boostrapConfig.api.authentication.secret
          };
          setTimeout(()=>{
            this.getConfig(this.state.appId);
          }, 300);
        });
        this.getConfig(boostrapConfig.appId);
      } else if (window.location.href.includes('?appId=')) {
        let id = window.location.href.split('?appId=')[1];
        if (window.location.href.includes('&locationId')) {
          id=id.split('&')[0];
          console.log(id);
        }
        this.state.appId = Number(id);
        this.getConfig(id);
      } else {
          if (boostrapConfig.mode === 'ROAMLITE') {
            this.state.isRoamLite = true;
          }
          else if(boostrapConfig.mode === 'ROOMBOOKER') {
            this.state.roomBooker = true;
            statusBar.hide();
          }
          this.events.subscribe('staff:logout', () => {
            this.showLoadingScreen();
            this.state.appId = 0;
            this._staffProvider.clear();
            this.state.authentication = {
              key: boostrapConfig.api.authentication.key,
              secret: boostrapConfig.api.authentication.secret
            }
            this._db.resetDB();
            this._apiProvider.resetToken().then(() => {
              setTimeout(()=>{
                this.staffLogin();
              }, 300);
            });
          });
          this.staffLogin();
      }
      if (platform.is('core')) {
        this.state.mode = 'desktop';
      }
      this.state.cordovaAvailable = window.hasOwnProperty('cordova');
      //this.state.cordovaAvailable = true; //FOR TESTING
      this.setupBackButtonBehavior();
      // statusBar.styleLightContent();
      statusBar.backgroundColorByHexString(androidStatusBarColor);
      if (this.state.isSelfcheck) {
        platform.registerBackButtonAction(() => {
          this.events.publish('closeKeyboard');
        });
      }
    },((error) => {
      alert(error);
    }));
  }

  staffLogin() {
    this.splashScreen.hide();
    this.authStaffUser({'staff': true, clientId: 0}).then(res => {
      this.showLoadingScreen();
      if (this.state.staffCredentials.details.access.level == 1) {
        this._db.resetDB();
      }
      if (this.state.isRoamLite) {
        this.getRoamLiteConfig();
      }
      else if (this.state.roomBooker && this.state.cordovaAvailable) {
        this.getRoomBookerConfig();
      }
    }, (error) => {
      alert("something went wrong");
    });
  }

  getRoamLiteConfig() {
    this.config.getAllApps("ROAMLITE").then(apps => {
      if (apps.length > 1 && this.state.staffCredentials.details.access.level == 1) {
        this.showAppSelector(apps);
      } else {
        boostrapConfig.appId = apps[0].id;
        this.state.appId = apps[0].id;
        if (this.state.staffCredentials.details.access.level == 1) {
          this._staffProvider.authUser(this.state.staffCredentials.username, this.state.staffCredentials.password, {'staff':true}, apps[0].clientId).then((staffDetails) => {
            this.promptForLocation(apps[0].id);
          })
        } else {
          this.promptForLocation(apps[0].id);
        }
      }
    });
  }

  getRoomBookerConfig() {
    this.config.getAllApps("ROOMBOOKER").then(apps => {
      if (apps.length > 1 && this.state.staffCredentials.details.access.level == 1) {
        this.showAppSelector(apps);
      } else {
        this.config.load(apps[0].id).then( cfg => {
          this.state.staffAuthorized = false;
          this.state.staffCredentials = {
            username: undefined,
            password: undefined,
            details: undefined,
          }
          boostrapConfig.appId = apps[0].id;
          this.state.appId = apps[0].id;
          this.promptForLocation(apps[0].id);
        });
      }
    });
  }

  showAppSelector(apps) {
    let modal = this.modalCtrl.create(CoAppSelectorPage, {apps: apps}, { cssClass: 'full-screen-modal', enableBackdropDismiss: false });
    modal.onWillDismiss(() => {
      if (!this.state.appId) {
        alert('No app config selected, please select a config.');
        modal.present();
      }
    });
    modal.present();
    this.events.subscribe('SelectedAppId', (appId) => {
      modal.dismiss().catch(err=>{});
        boostrapConfig.appId = appId.id;
        this.state.appId = appId.id;
        this._staffProvider.authUser(this.state.staffCredentials.username, this.state.staffCredentials.password, {'staff':true}, appId.clientId).then((staffDetails) => {
          this.promptForLocation(appId.id);
        });
    });
  }

  keyboardPressed(input, target){
    target.value = input;
    console.log("Input changed", input);
  }
  onKeyPress(button){
    console.log("Button pressed", button);
  }

  authStaffUser(cfg):Promise<any>{
    return new Promise((res, rej)=>{
      if (cfg.staff && !cfg.demo && !this.state.staffAuthorized){
        this._staffProvider.load().then((staffDetails) => {
          let authRequired = true;
          if (staffDetails){
            if (this.state.staffAuthorized = true) {
              authRequired = false;
              res(true);
            }
          }
          if (authRequired) {
            let modal = this.modalCtrl.create(CoRoamLoginComponent, {config: cfg}, {cssClass: 'full-screen-modal', enableBackdropDismiss: false});
            modal.present();

            modal.onWillDismiss(() => {
              if (!this.state.staffCredentials || !this.state.staffCredentials.details) {
                alert('Please log in');
                modal.present();
              }
            });

            modal.onDidDismiss(data =>{
              res(true);
            });
          }
        });

      } else {
        res(true);
      }
    });
  }

  promptForLocation(appId) {

    // this.splashScreen.show();
      this.events.subscribe('refreshConfig', () => {
        this.getConfig(this.state.appId);
      });
      this.getConfig(appId);
      // }
    // });
  }
  getConfig(appId) {
    this.config.load(appId).then(cfg => {
      this.splashScreen.hide();
      this.authStaffUser(cfg).then(()=>{
        const urlParams = new URLSearchParams(window.location.search.toLowerCase());
        if (urlParams.get('locationid')) {
          const locationId = parseInt(urlParams.get('locationid'));
          this.state.locationId = locationId;
          this.getBranchInformation(cfg);
        } else if (!cfg.locationId && cfg.promptForLocation) {
          this.initializeApp(cfg).then(() => {
            this._db.get("staffCredentials").then((result) => {
              if (result && result.locationId){
                this.state.locationId = result.locationId;
                this.getBranchInformation(cfg);
              } else {
                this.splashScreen.hide();
                let modal = this.modalCtrl.create(CoLocationSelectorPage, {}, { cssClass: 'full-screen-modal', enableBackdropDismiss: false });
                modal.onWillDismiss(() => {
                  if (!this.state.locationId) {
                    alert('No location selected, please select a location.');
                    modal.present();
                  }
                });
                modal.present();
                this.events.subscribe('locationSelected', (location) => {
                  this.state.locationId = location.id;
                  modal.dismiss().catch(err=>{});
                  this.getBranchInformation(cfg);
                  this.events.unsubscribe('locationSelected');
                });
              }
            })
          });
        } else if (cfg.locationId) {
          this.state.locationId = cfg.locationId;
          this.getBranchInformation(cfg);
        } else {
          this.initializeApp(cfg).then(() => {
            this.state.locationId =  this.state.locationId ?  this.state.locationId : null;
            this.goToApp(cfg);
          });
        }
      });
    });
  }

  getBranchInformation(cfg) {
    this.locations.getLocation(this.state.locationId).then(info => {
      if (info) {
        this.state.branchInformation = info;
      }
      this.initializeApp(cfg).then(() => {
        this.goToApp(cfg);
      });
    });
  }

  async initializeApp(cfg) {
    // console.log(cfg)
	if(!cfg.settings){
		cfg.settings={};
	}

	let savecfg = cfg;
    this.state.header = cfg.header;
    this.state.footer = cfg.footer;
    this.state.demo = cfg.demo;
    this.state.staff = cfg.staff;
    this.state.scrollArrows = cfg.scrollArrows;
    this.state.htmlKeyboard = cfg.htmlKeyboard;
    this.state.burgerMenu = cfg.burgerMenu || { menuSide: 'hidden' };
    this.state.enableOnScreenKeyboard = cfg.enableOnScreenKeyboard || false;
    this.state.hideHeaderLogo = cfg.hideHeaderLogo || false;
    this.state.pinless = cfg.pinless || false;
	  this.state.enableSounds = cfg.enableSounds || false;
    this.state.cityStateList = cfg.settings.cityStateList || false;
    this.state.roomBooker = cfg.settings.roomBooker || false;
    this.state.patronLookupByText = cfg.settings.patronLookupByText == false ? false : true;
    if (cfg.settings.newPatronHeader) this.state.newPatronHeader = cfg.settings.newPatronHeader;
    this.state.surveyEnabled = cfg.settings.surveyEnabled || false;
    this.state.customStrings = cfg.settings.customStrings || {};
    this.state.customImages = cfg.settings.customImages || {};
    this.state.showNovelistOnLogout = cfg.settings.showNovelistOnLogout || false;
    this.state.novelistTimeoutNumber = cfg.settings.novelistTimeoutNumber || 20000;
    this.state.directSip2 = cfg.settings.directSip2 || false;
    this.state.selfcheckPayments = cfg.settings.selfcheckPayments || false;
    this.state.receiptTemplates = cfg.settings.receiptTemplates || false;
    this.state.hideOverviewTab = cfg.settings.hideOverviewTab || false;
    this.state.hideReviewsTab = cfg.settings.hideReviewsTab || false;
    this.state.hidePlaceHold = cfg.settings.hidePlaceHold || false;
    this.state.hasNovelist = cfg.settings.hasNovelist || false;
    this.state.pickupLocation = cfg.settings.pickupLocation || false;
    this.state.overrideILSauth = cfg.settings.overrideILSauth || false;
    this.state.reverseNameOrder = cfg.settings.reverseNameOrder || false;
    this.state.reserveSignInBookingDate = cfg.settings.reserveSignInBookingDate || false;
    this.state.defaultSearchBy = cfg.settings.defaultSearchBy || ['title','author','any field'];
    this.state.ignorePromptForReceipt = cfg.settings.ignorePromptForReceipt || false;
    this.state.defaultSearchBy = cfg.settings.defaultSearchBy || ['title','author','any field'];
    this.state.searchLinks = cfg.searchLinks || [];
    this.state.disablePrinting = cfg.settings.disablePrinting || false;
    this.state.physicalScanner = cfg.settings.physicalScanner || false;
    this.state.isRoam = cfg.settings.roam || false;
    this.state.isSelfcheck = cfg.settings.selfcheck || false;
    this.state.scanIntoPage = cfg.settings.scanIntoPage || 'selfcheck-checkout';
    this.state.reserveSignIn = cfg.settings.reserveSignIn || false;
    this.state.preventLogin = cfg.settings.preventPatronLogin  || false;
    this.state.disableHomeScreenScanning = cfg.settings.disableHomeScreenScanning || false;
    this.state.showPatronAlerts = cfg.settings.showPatronAlerts || false;
    this.state.showPatronNotes = cfg.settings.showPatronAlerts || false;
    this.state.omitCardFromReserveBooking = cfg.settings.omitCardFromReserveBooking ||  false;
    this.state.disableCartBackdropDismiss = cfg.settings.disableCartBackdropDismiss || false;
    if (cfg.settings.patronFields) {
      this.state.patronFields = cfg.settings.patronFields;
    }

    this.state.preventAccountEdit = {
      email: cfg.settings.preventEmailEdit || false,
      phone: cfg.settings.preventPhoneEdit || false,
      address: cfg.settings.preventAddressEdit || false,
      branch: cfg.settings.preventBranchEdit || false,
      pin: cfg.settings.preventPinEdit || false,
      name: cfg.settings.preventNameEdit || false,

      manualBlock: "preventManualBlockEdit" in cfg.settings ? cfg.settings.preventManualBlockEdit : true,
      residentCategory: "preventResidentCategoryEdit" in cfg.settings ? cfg.settings.preventResidentCategoryEdit : true,
      patronType: "preventPatronTypeEdit" in cfg.settings ? cfg.settings.preventPatronTypeEdit : true,
      noticePreference: "preventPatronTypeEdit" in cfg.settings ? cfg.settings.preventPatronTypeEdit : true,
      cardCampaign: "preventCardCampaignEdit" in cfg.settings ? cfg.settings.preventCardCampaignEdit : true,
      dob: "preventDobEdit" in cfg.settings ? cfg.settings.preventDobEdit : true,
    }
    this.state.patronLookupFields = {
      firstName: cfg.settings.patronLookupFields && "firstName" in cfg.settings.patronLookupFields ? cfg.settings.patronLookupFields.firstName : true,
      lastName: cfg.settings.patronLookupFields && "lastName" in cfg.settings.patronLookupFields ? cfg.settings.patronLookupFields.lastName : true,
      zip: cfg.settings.patronLookupFields && "zip" in cfg.settings.patronLookupFields ? cfg.settings.patronLookupFields.zip : true,
    }
    this.state.checkingForAnotherPatron = false;
    this.state.currencyCode = cfg.settings.currencyCode || "USD";
    this.state.internationalDate = cfg.settings.internationalDate || false;
    this.state.internationalTime = cfg.settings.internationalTime || false;
    this.state.internationalAddress = cfg.settings.internationalAddress || false;
    this.state.alphanumericPatronBarcode = cfg.settings.alphanumericPatronBarcode || false;
    this.state.showAttendees = cfg.settings.showAttendees || false;
    if (cfg.settings.searchSource) this.state.searchSource = cfg.settings.searchSource;
    if (this.state.searchSource === 'discover'){
      this.state.defaultSearchBy = [
        { 'v': 'full', 't': 'Any Field' },
        { 'v': 'ti', 't': 'Title' },
        { 'v': 'cr.n', 't': 'Author' },
        { 'v': 'ids.v', 't': 'ISBN' },
        { 'v': 'sb', 't': 'Subject' }
      ];
    }
    if (cfg.libraryCardPlaceholderImg && cfg.libraryCardPlaceholderImg.length > 0) {
      this.state.libraryCardPlaceholderImg = cfg.libraryCardPlaceholderImg;
    } else {
      this.state.libraryCardPlaceholderImg = "";
    }
    this.burgerMenu = this.state.burgerMenu;
    this.state.enableSounds = cfg.enableSounds || false;
    this.listProvider.getList('allUsers').then((res) => {
      // console.log(res);
    });
    // this.burgerMenu && this.burgerMenu.menuSide ? this.menuSide = this.burgerMenu.menuSide : this.menuSide = "hidden";
    this.menuSide = this.state.burgerMenu.menuSide;
    this.state.nav = this.nav;

    this.ils.getSearchTypes().then(res => this.state.searchByList = res);
    this.ils.getSearchFilters().then(res => this.state.limitByList = res);
    this.ils.getSortTypes().then(res => this.state.sortByList = res);

    if (cfg.timeoutInterval) {
      this.timeoutProvider.initializeTimeout(cfg.timeoutInterval, cfg, cfg.settings.timeoutWarning || 15000);
      this.state.timeoutEnabled = true;
      this.state.timeoutInterval = cfg.timeoutInterval;
      this.state.timeoutWarning = cfg.settings.timeoutWarning;
    }

    if (this.state.enableOnScreenKeyboard) { // OSK FOR ELECTRON

      this.events.subscribe('closeKeyboard', async ()=> {
		if(this.oskShowTimer)clearTimeout(this.oskShowTimer);
        if (this.osk && this.state.enableOnScreenKeyboard){
		  await this.osk.dismiss(null, '', {animate: false}).catch(()=>{});
          this.osk =  null;
        }
      });
      //
      // ****  Open and position OSK on click in inputs. ****
      document.addEventListener('focus', async (event) => {
        let targ = event.target as HTMLElement;
        if (targ.tagName === 'INPUT' || targ.tagName === 'TEXTAREA') {
			if(this.oskCloseTimer)clearTimeout(this.oskCloseTimer);

          if (this.osk){
			  this.events.publish('setOSKTarget', targ);
            // await this.osk.dismiss(null, '', {animate: false}).catch(()=>{});
            // this.osk =  null;
          }else{
			this.osk = this.popoverCtrl.create(CoNgxKeyboardComponent,{target: targ}, {cssClass: 'custom-keyboard-popover-bottom'});
			this.osk.present({animate: false}); //**** UNCOMMENT THIS TO ENABLE KEYBOARD ****
		  }
        }
      }, true);

	  document.addEventListener('mousedown', (event)=>{ //adds event listener to document to close keyboard if clicked outside
        if (this.osk){
          let keyboard = document.getElementsByClassName('coKeyboardContainer')[0];
		  let targ = event.target as HTMLElement;
          if (targ !== keyboard && !keyboard.contains(targ)){
			this.oskCloseTimer = setTimeout(()=>{
				this.events.publish('closeKeyboard');
			}, 150);
		  }
        }
      })
    }

    // let queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    // setTimeout(()=>{
    //   this.eventsProvider.getEvents(queries);
    // },0);

    // setInterval(()=>{
    //   let queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    //   this.eventsProvider.getEvents(queries);
    // }, 900000);

    if (cfg.mode && cfg.mode.length > 0) {
      this.state.mode = cfg.mode;
    }
    this.state.autologoutPosition = cfg.autologoutPosition;

    cfg.sharedScreen ? this.state.sharedScreen = cfg.sharedScreen : this.state.sharedScreen = false;
    this.state.client = await this.clientDetails.load();
    if (document.title.length === 0) document.title = this.state.client.longName;

    //DIGITAL SERVICES CHECK
    this.state.digitalServices = {
      axis360: false,
      cloudlibrary: false,
      hoopla: false,
      overdrive: false,
      zinio: false,
      bolinda: false
    };
    this.state.digitalServices.axis360 = this.state.client.settings.app_axis360_enabled;
    this.state.digitalServices.bolinda = false;
    this.state.digitalServices.cloudlibrary = this.state.client.settings.app_cloudlibrary_enabled;
    this.state.digitalServices.hoopla = this.state.client.settings.app_hoopla_enabled;
    this.state.digitalServices.overdrive = this.state.client.settings.app_overdrive_enabled;
    this.state.digitalServices.zinio = this.state.client.settings.app_zinio_enabled;

    const tmpStyleEl = document.createElement('style');
    var text;
    // if (cfg.settings && cfg.settings.css) {
    text = document.createTextNode(this.getCss(cfg));
    // } else {
    //   text = document.createTextNode(this.getCss(cfg));
    // }
    tmpStyleEl.appendChild(text);
    document.head.appendChild(tmpStyleEl);
    tmpStyleEl.className = 'theme-style';

    if (this.state.mode == 'desktop' && cfg.theme) {
      fetch(`http://seasons.libnet.info/css/style/${cfg.theme.id}`).then(res => res.text()).then(css => {
        const tmpStyleEl = document.createElement('style');
        var text = document.createTextNode(css);
        tmpStyleEl.appendChild(text);
        document.head.appendChild(tmpStyleEl);
        tmpStyleEl.media = 'max-width: 1px';
        const rules = (tmpStyleEl.sheet as any).cssRules;
        tmpStyleEl.remove();

        const styleEl = document.createElement('style');
        document.head.appendChild(styleEl);
        const styleSheet = styleEl.sheet;
        for (var i in rules) {
          if (rules[i].selectorText) {
            if (rules[i].selectorText === 'body') rules[i].selectorText = '.fakebody';
            rules[i].selectorText = rules[i].selectorText.split(',').join(', div.fakebody');
          }
          try {
            if (rules[i].cssText) (styleSheet as any).insertRule('div.fakebody ' + rules[i].cssText);
          } catch (err) {
            // console.log(err, rules[i].cssText); //not sure we care really
          }
        }

      });
    }

    if(cfg.settings && cfg.settings.customTheme) {
      this.getCustomTheme(cfg.settings.customTheme);
    }

    // if(this.state.mode=='desktop'){
    //   this.nav.setRoot(HomePage);
    // }else{

    // }
    this.loginProvider.definePatronCollection()
    .then(()=>this.loginProvider.getPatronCollection())
    .then((patrons)=>{
      if (patrons.length>0){
        patrons.forEach(p => {
          this.loginProvider.login(p.barcode, p.pin);
        });
      }
    });
    this.analytics.initAnalytics();
  }

  private showLoadingScreen() {
    this.nav.setRoot(LoadingPage).then(()=> this.splashScreen.hide());
  }

  private goToApp(cfg) {
    const screen = cfg.screens.find(screen => screen.name == 'home');
    if (screen && screen.title) document.title = screen.title;
    this.nav.setRoot(ScreenPage, { screenData: screen }).then(()=> this.splashScreen.hide());
  }

  private setupBackButtonBehavior() {

    // If on web version (browser)
    if (window.location.protocol !== "file:") {

      // Register browser back button action(s)
      window.onpopstate = (evt) => {

        // Close menu if open
        if (this._menu.isOpen()) {
          this._menu.close();
          return;
        }

        // Close any active modals or overlays
        let activePortal = this._ionicApp._loadingPortal.getActive() ||
          this._ionicApp._modalPortal.getActive() ||
          this._ionicApp._toastPortal.getActive() ||
          this._ionicApp._overlayPortal.getActive();

        if (activePortal) {
          activePortal.dismiss().catch((err) => { console.log('gotcha (in dismiss)', err) });
          return;
        }
        var myNav = this._app.getActiveNavs()[0];
        // Navigate back
        if (myNav.canGoBack()) myNav.pop();

        // // Navigate back
        // if (this._app.getRootNav().canGoBack()) this._app.getRootNav().pop();

      };

      // Fake browser history on each view enter
      this._app.viewDidEnter.subscribe((app) => {
        history.pushState(null, null, "");
      });

    }

  }
  private getGrad(start, color) {
    if (!color) return "";
    return "background: -webkit-linear-gradient(" + start + ", " + color.color1 + " 0%," + color.color2 + " " + parseInt(color.split, 10) + "%," + color.color3 + " " + (parseInt(color.split, 10) + 1) + "%," + color.color4 + " 100%);\n" +
      "background: -moz-linear-gradient(to " + start + ", " + color.color1 + " 0%," + color.color2 + " " + parseInt(color.split, 10) + "%," + color.color3 + " " + (parseInt(color.split, 10) + 1) + "%," + color.color4 + " 100%);\n" +
      "background: -ie-linear-gradient(to " + start + ", " + color.color1 + " 0%," + color.color2 + " " + parseInt(color.split, 10) + "%," + color.color3 + " " + (parseInt(color.split, 10) + 1) + "%," + color.color4 + " 100%);\n" +
      "background: linear-gradient(to " + start + ", " + color.color1 + " 0%," + color.color2 + " " + parseInt(color.split, 10) + "%," + color.color3 + " " + (parseInt(color.split, 10) + 1) + "%," + color.color4 + " 100%);\n";
  }
  private getCss(cfg) {
    const theme = cfg.theme;
    const settingsTheme = cfg.settings && cfg.settings.css? cfg.settings.css : null;
    var css = '\n';
    if (theme.headerLogo) {
      // http://stark.libnet.info/images/logos/stark/LogoHorizontal-2018.png
      this.state.headerLogo = theme.headerLogo;
    }
    if (theme.widgetSubheadingColor) {
      let lightColor = this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, .6);
      css += '.co-button, .co-button:hover, .co-button:visited, .co-segment{\n';
      css += 'color:' + theme.widgetTitleTextColor + ';\n';
      css += 'border-color:' + theme.widgetBorderColor + ';\n';
      css += 'border-radius:' + theme.widgetBorderRadius + 'px;\nbottom';
      css += 'border-width:' + theme.widgetBorderSize + 'px;\n';
      css += this.getGrad('bottom', theme.widgetHeaderColor);
      css += '}\n';

      //   .segment-md-danger .segment-button.activated, .segment-md-danger .segment-button.segment-activated{
      //     border-color: #e86767;
      //     color: #e86767;
      // }
      // .segment-md-danger .segment-button{
      //     color: #e86767;
      // }

      css += '.segment-md-communico .segment-button.activated, .segment-md-communico .segment-button.segment-activated{\n';
      css += 'color:' + theme.widgetSubheadingColor + '!important;\n';
      css += '}\n';

      css += '.segment-md-communico .segment-button.activated .co-segment-dec, .segment-md-communico .segment-button.segment-activated .co-segment-dec{\n';
      css += 'background:' + theme.widgetBorderColor + '!important;\n';
      css += '}\n';

      css += '.segment-md-communico .segment-button, .co-theme-button-color{\n';
      css += 'color:' + theme.widgetTitleTextColor + ';\n';
      css += this.getGrad('bottom', theme.widgetHeaderColor);
      css += '}\n';


      css += '.custom-block-icon path{\n';
      css += 'fill:' + theme.widgetTitleTextColor + ';\n';
      css += '}\n';

      css += '.button-md-communico, .button-ios-communico{\n';
      css += 'background:' + theme.buttonBackgroundColor.color1 + '!important;\n';
      css += 'color:' + theme.buttonTextColor + ' !important;\n';
      css += 'border-color:' + theme.buttonFrameColor + ';\n';
      css += '}\n';

      css += '.button-outline-md-communico, .button-outline-ios-communico{\n';
      css += 'background-color: #f7f7f7 !important;\n';
      css += 'color:' + theme.buttonBackgroundColor.color1 + ' !important;\n';
      css += 'border-color:' + theme.buttonFrameColor + ';\n';
      css += '}\n';

      css += '.gradbutton{\n';
      css += 'color:' + theme.buttonTextColor + ' !important;\n';
      css += 'border-color:' + theme.buttonFrameColor + ';\n';
      css += 'border-radius:' + theme.buttonBorderRadius + 'px;\n';
      css += 'font-weight:' + theme.buttonWeight + 'px;\n';
      css += 'border-width:' + theme.buttonBorderSize + 'px;\n';
      css += this.getGrad('bottom', theme.buttonBackgroundColor);
      css += '}\n';
      css += 'a.gradbutton:hover, a.gradbutton:visited, .button-text-color{\n';
      css += 'color:' + theme.buttonTextColor + ';\n';
      css += '}\n';

      css += '.headerbar{\n';
      css += this.getGrad('bottom', theme.headerBackgroundColor);
      css += '}\n';

      css += '.librarycard{\n';
      css += this.getGrad('bottom', theme.headerBackgroundColor);
      css += '}\n';

      css += '.headerbar .title, .headerbar .button{\n';
      css += 'color:' + theme.headerTextColor + ';\n';
      css += '}\n';

      css += '.subheading{\n';
      css += 'color:' + theme.widgetSubheadingColor + ' !important;\n';
      css += '}\n';
      css += '.footerLinkColour{\n';
      css += 'color:' + theme.footerLinkColor + ' !important;\n';
      css += '}\n';

      css += '.button.button-positive, .button.button-positive:hover, .co-segment{\n';
      css += 'color:' + theme.buttonTextColor + ' !important;\n';
      css += 'border-color:' + theme.buttonFrameColor + ';\n';
      css += this.getGrad('bottom', theme.buttonBackgroundColor.color1);
      css += '}\n';

      css += '.tabs-background-positive .tabs \n';
      css += '.tabs-background-positive > .tabs {\n';
      css += this.getGrad('bottom', theme.widgetHeaderColor);
      css += 'border-color:' + theme.buttonFrameColor + ';\n';
      css += '}\n';

      css += '.tabs-striped.tabs-background-positive .tabs, .backgroundColorChange {\n';
      css += 'background-color: ' + theme.widgetHeaderColor.color1 + ' !important;\n';
      css += 'background-image: none; }\n';

      css += '.tabs.search-results-tabs {\n';
      css += 'border-bottom: 3px solid ' + theme.widgetHeaderColor.color1 + '; }\n';

	  css += '.headerButtons{\n';
	  css += 'border: 1px solid ' + theme.buttonBackgroundColor.color1+ ' !important;\n';
	  css += 'background: ' +  theme.buttonTextColor + ' !important;\n';
	  css += 'color: ' + theme.buttonBackgroundColor.color1+ ' !important;\n';
    css += '}\n';

      // css += '.fontColorChange {\n';
      // css += 'color: ' + theme.widgetHeaderColor.color1 + ' !important;\n';
	  // css += '}\n';

      css += ':root { \n';
      css += '--primaryText: ' + theme.buttonBackgroundColor.color1 + ' !important;\n';
      css += '--primaryBackground: ' + theme.buttonBackgroundColor.color1 + ' !important;\n';
      css += '--headerBackground: ' + (this.state.sharedScreen && !this.state.roomBooker? '#2e3945' : theme.headerBackgroundColor.color1) + ' !important;\n';
      css += '--headerText: ' + theme.headerTextColor + ' !important;\n';
      css += '--light: ' + lightColor + ' !important;\n';
      css += '--alternate: ' + theme.linkHoverColor + ' !important;\n';
      css += '--scanText1: #1a8cd6 !important;\n'; //DEFAULT ADDED IN FOR CURRENT SELF CHECKS TOLEDO AND CUYAHOGA, CAN OVERWRITE WITH CSS VARIABLES IN CONFIG SETTINGS
      css += '--selfcheckButtons: #2e3945 !important;\n'; //DEFAULT ADDED IN FOR CURRENT SELF CHECKS TOLEDO AND CUYAHOGA, CAN OVERWRITE WITH CSS VARIABLES IN CONFIG SETTINGS
      css += '--selfcheckHeaderText: #e88908 !important;\n'; //DEFAULT ADDED IN FOR CURRENT SELF CHECKS TOLEDO AND CUYAHOGA, CAN OVERWRITE WITH CSS VARIABLES IN CONFIG SETTINGS
      css += '--gradToRight: linear-gradient(to right, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, 0) + ' 0%, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, .1) + ' 100%) !important;\n';
      css += '--gradToLeft: linear-gradient(to right, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, .1) + ' 100%, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, 0) + ' 0%) !important;\n';
      css += '--gradToBottom: linear-gradient(to bottom, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, 0) + ' 0%, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, .1) + ' 100%) !important;\n';
      css += '--gradToTop: linear-gradient(to bottom, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, .1) + ' 100%, ' + this.colorConvert.hexToRgba(theme.buttonBackgroundColor.color1, 0) + ' 0%) !important;\n';

      if (settingsTheme) {
        settingsTheme.forEach((value, i) => {
          var key = Object.keys(value)[0];
          css += `${key}: ${value[key]} !important;\n`;
        });
      }

      css += '}\n';


    }
    // console.log(css);
    return css;
  }

  private getCustomTheme(theme) {
    const customThemeLink =  document.createElement('link');
    customThemeLink.rel = 'stylesheet';
    customThemeLink.href = `assets/css/themes/${theme}.css`;
    document.getElementsByTagName('head')[0].appendChild(customThemeLink);
  }

  loadIfNot(url, cssId) {
    if (!document.getElementById(cssId)) {
      var head = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      link.media = 'all';
      head.appendChild(link);
    } else {
      //  document.getElementById(cssId).disabled = false;///i fit's already there, enable it
    }

  }

  getButtonParamsForBlock(block): coButton {
    return {
      text: block.title,
      color: "primary",
      icon: block.icon,
      full: true,
      linkURL: block.url,
      block: block,
      square: block.square || false
    }
  }

  login() {
    this.loginProvider.requireLogin(() => {

    });
  }

  logout() {
    this.loginProvider.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts